import { Check } from "lucide-react"

import { BundleCard } from "@/components/tuw/post/EntryPicker"
import { ErrorLine } from "./UploadControl"

// The bundle step's choice: today's bundle cards (EntryPicker's BundleCard:
// name, tagline, included items, note, "From" price, the "Most popular" tag and
// the audiobook lock), from the catalog's bundles.
//
// Props: bundles (catalog.bundles), value (the chosen bundle_tier), error, onChoose(tier).
export function BundleChoice({ bundles = [], value, error, onChoose }) {
  return (
    <div className="flex flex-col gap-3">
      {bundles.map((bundle) => (
        <BundleCard
          key={bundle.bundleTier}
          bundle={bundle}
          on={value === bundle.bundleTier}
          onClick={() => onChoose(bundle.bundleTier)}
        />
      ))}
      <ErrorLine>{error}</ErrorLine>
    </div>
  )
}

// Something the package already includes, shown in place of a choice: an
// outline in an outline bundle, source files with a Platinum cover.
export function IncludedLine({ text }) {
  return (
    <div className="flex items-start gap-2.5 rounded-xl border border-border bg-card px-4 py-3.5">
      <span className="mt-px grid size-5 shrink-0 place-items-center rounded-full bg-[var(--green-soft,var(--secondary))] text-done">
        <Check className="size-3" strokeWidth={3} />
      </span>
      <span className="min-w-0 text-[13px] font-semibold text-foreground">{text}</span>
    </div>
  )
}
